import React, { useRef, useState, useEffect } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { OrbitControls, useGLTF } from '@react-three/drei';

const Model = ({ url, scale, position }) => {
  const groupRef = useRef();
  const { scene } = useGLTF(url);

  useFrame(() => {
    if (groupRef.current) {
      groupRef.current.rotation.y += 0.01;
    }
  });

  return (
    <group ref={groupRef}>
      <primitive 
        object={scene} 
        position={position}
        //scale={scale}
      />
    </group>
  );
};

const ModelViewer = ({ modelPath }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Ajustes modificados: Valores Y más negativos para bajar las figuras
  const scale = isMobile ? [1.5, 1.5, 1.5] : [0.8, 0.8, 0.8];
  const position = isMobile ? [0, -3, 0] : [0, -2, 0]; // Ajustado aquí
  const cameraPosition = isMobile ? [0, 0.8, 6] : [0, 0.5, 7];
  const fov = isMobile ? 35 : 35;

  return (
    <Canvas camera={{ position: cameraPosition, fov }}>
      <ambientLight intensity={0.4} />
      <directionalLight position={[3, 3, 3]} />
      <Model 
        url={modelPath}
        //scale={scale}
        position={position}
      />
      <OrbitControls enableZoom={false} />
    </Canvas>
  );
};

export default ModelViewer;